import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid ,CircularProgress} from '@mui/material';

import { openDrawer } from './../../../store/slice/MenuSlice';
import { setProductDashboardProductList, setSelectedPharmaorderId } from 'store/slice/PharmaSlice';

import { getListAPI as getProductList } from 'components/product/ProductAPI';
import { setProductList } from 'store/slice/PharmaSlice';
import { getMyTaskListAPI } from 'api/CorePlatformserviceWebServices';
import { setTaskList } from 'store/slice/AppSlice';

import ProductDashboard from '../ProductDashboard';
import { use } from 'react';
export default function DesignerProductPage() {
    const dispatch = useDispatch();
    const {productList} = useSelector((state)=>state.pharmaslice)
    const getProductListSuccess = (list) =>{dispatch(setProductList(list));}
    const {apiInProgress} = useSelector((state)=>state.headerslice);
    const {userprofileInfo} = useSelector((state)=>state.headerslice);
    const {taskList} = useSelector((state)=>state.appslice.wkflow);
    
    useEffect(()=>{
        dispatch(setProductDashboardProductList([]));
    
        if (!taskList || taskList.length === 0) return;
        // If taskList is empty, do not filter productList
        if (!productList || productList.length === 0) return;
        // If productList is empty, do not filter taskList
        
        // Get all boobjid from taskList where taskstatusid is 2
        console.log("taskList: ", JSON.stringify(taskList));
        console.log(
          "taskList ids and status: ",
          taskList
            .filter(taskObj => taskObj.taskstatusid == 2)
            .map(task => ({ id: task.id, boobjid: task.boobjid, taskstatusid: task.taskstatusid }))
        );
        const taskProductIds = taskList
          .filter(task => task.taskstatusid == 2) // loose equality, matches both "2" and 2
          .map(task => task.boobjid);
        // Filter products whose id is in taskProductIds
        console.log("taskProductIds: ", productList.filter(productObj => taskProductIds.includes(productObj.id)));
        dispatch(setProductDashboardProductList(
          productList.filter(productObj => taskProductIds.includes(productObj.id))
        ));
    },[taskList, productList])
    
    useEffect(() => {
        dispatch(setSelectedPharmaorderId(-1));
        dispatch(openDrawer({drawerOpen:true}));
        getProductList(()=>{}, getProductListSuccess);

        getMyTaskListAPI({
            "roleName":"ROLE_"+userprofileInfo.rolename
        },
        (response)=>{
            dispatch(setTaskList(response.taskinstanceInfoList.list))
        },
        (apiErrMsg)=>{
            console.error("Error fetching task list: ", apiErrMsg);
        });

       
    },[]);

    return (
        <>
        {apiInProgress?
        <Grid container direction="row" sx={{height:'68vh', alignItems:'center', justifyContent:'center'}}>
        <CircularProgress/>
      </Grid>
      :<ProductDashboard/>}
      </>
        
    )

}